import type { WhaleHandlerIdentity } from "@vida/wave-core";
import { WaveAgentAvatar } from "./WaveAgentAvatar";

const MAX_VISIBLE = 3;
const STACK_OFFSET_RATIO = 0.6;

type Props = {
  handlers: WhaleHandlerIdentity[];
  size?: number;
  className?: string;
};

export function WaveAgentAvatarStack({
  handlers,
  size = 32,
  className = "",
}: Props) {
  if (!handlers.length) return null;

  const visible = handlers.slice(0, MAX_VISIBLE);
  const overflow = handlers.length - visible.length;
  const stackWidth = size + (visible.length - 1) * size * STACK_OFFSET_RATIO;
  const title = handlers.map((h) => h.agentName).join(", ");

  return (
    <span
      className={`wave-agent-avatar-stack${className ? ` ${className}` : ""}`}
      style={{ width: stackWidth, height: size }}
      title={title}
      aria-label={title}
    >
      {visible.map((handler, index) => (
        <span
          key={`${handler.agentId}-${index}`}
          className="wave-agent-avatar-stack-item"
          style={{
            left: index * size * STACK_OFFSET_RATIO,
            zIndex: visible.length - index,
          }}
        >
          <WaveAgentAvatar
            name={handler.agentName}
            emoji={handler.agentIcon}
            iconS3Key={handler.agentIconS3Key}
            size={size}
          />
        </span>
      ))}
      {overflow > 0 && (
        <span
          className="wave-agent-avatar-stack-overflow"
          style={{ left: visible.length * size * STACK_OFFSET_RATIO }}
          aria-hidden
        >
          +{overflow}
        </span>
      )}
    </span>
  );
}
